import WisdomNavbar from "components/navbars/WisdomNabvar";
import { useAuth } from "context/AuthContext";
import { useLanguage } from "context/LanguageContext";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchWisdomClasses, fetchWisdomGradebookScores, fetchWisdomRelatedGradebooks, fetchWisdomRelatedSchools, fetchWisdomRelatedStudents, fetchWisdomRelatedTeachers, fetchWisdomStages, fetchWisdomSubjects } from "services/wisdom/wisdomData";
import { postInsertGradeBookScore } from "services/wisdom/wisdomPms";
import * as XLSX from "xlsx";

const WisdomInsertGradeBook = () => {
    const { userInfo } = useAuth();
    const navigate = useNavigate();
    const { language } = useLanguage();
    const [schools, setSchools] = useState([]);
    const [subjects, setSubjects] = useState([]);
    const [filteredSubjects, setFilteredSubjects] = useState([]);
    const [gradebooks, setGradebooks] = useState([]);
    const [filteredGradebooks, setFilteredGradebooks] = useState([]);
    const [selectedSchool, setSelectedSchool] = useState("");
    const [selectedSubject, setSelectedSubject] = useState("");
    const [selectedType, setSelectedType] = useState("");
    const [selectedCategory, setSelectedCategory] = useState("");
    const [stages, setStages] = useState([]);
    const [selectedStage, setSelectedStage] = useState("");
    const [classes, setClasses] = useState([]);
    const [filteredClasses, setFilteredClasses] = useState([]);
    const [selectedClass, setSelectedClass] = useState("");
    const [students, setStudents] = useState([]);
    const [filteredStudents, setFilteredStudents] = useState([]);
    const [teachers, setTeachers] = useState([]);
    const [FilteredTeachers, setFilteredTeachers] = useState([]);
    const [studentsScores, setStudentsScores] = useState([]);
    const [form, setForm] = useState({
        template_id: "",
        teacher_id: ""
    });
    const [studentScoreRows, setStudentScoreRows] = useState([
        {
            student_id: "",
            score: ""
        }
    ]);
    const [dateFrom, setDateFrom] = useState("");
    const [dateTo, setDateTo] = useState("");

    useEffect(() => {
        const loadSchools = async () => {
            const response = await fetchWisdomRelatedSchools();
            setSchools(response);
        };

        const loadSubjects = async () => {
            const response = await fetchWisdomSubjects();
            setSubjects(response);
            setFilteredSubjects(response);
        };

        const loadGradebooks = async () => {
            const response = await fetchWisdomRelatedGradebooks();
            setGradebooks(response);
            setFilteredGradebooks(response);
        }

        const loadStages = async () => {
            const response = await fetchWisdomStages();
            setStages(response);
        }

        const loadClasses = async () => {
            const response = await fetchWisdomClasses();
            setClasses(response);
            setFilteredClasses(response);
        }

        const loadStudents = async () => {
            const response = await fetchWisdomRelatedStudents();
            setStudents(response);
            setFilteredStudents(response);
        }

        const loadTeachers = async () => {
            const response = await fetchWisdomRelatedTeachers();
            if (userInfo?.user_role === "Teacher") {
                const my_id = response.find(teacher => teacher.employee_id === userInfo?.employee_id);
                setForm((p) => ({ ...p, teacher_id: my_id.id }))
            }
            setTeachers(response);
            setFilteredTeachers(response);
        }

        loadSchools();
        if (userInfo?.organization_id === 13) {
            loadSubjects();
        } else if (userInfo?.user_role === "Teacher" && userInfo?.teacher_subject?.length > 1) {
            setSubjects(userInfo?.teacher_subject);
            setFilteredSubjects(userInfo?.teacher_subject);
        }
        loadGradebooks();
        loadStages();
        loadClasses();
        loadStudents();
        loadTeachers();
    }, [userInfo]);

    useEffect(() => {
        const filterGradeBooks = () => {
            const filteredData = gradebooks.filter(gb => {
                const matchesSchool =
                    ((userInfo?.organization_id !== 13 && userInfo?.user_role === "Teacher")
                        ? gb.organization_id === Number(userInfo?.organization_id)
                        : selectedSchool === ""
                            ? true
                            : gb.organization_id === Number(selectedSchool));

                const matchesSubject =
                    ((userInfo?.organization_id !== 13 &&
                        userInfo?.user_role === "Teacher" &&
                        userInfo?.teacher_subject?.length === 1)
                        ? gb.subject_id === userInfo?.teacher_subject[0]?.id
                        : selectedSubject === ""
                            ? true
                            : gb.subject_id === Number(selectedSubject));

                const matchesType =
                    selectedType === "" ? true : gb.type === selectedType;

                const matchesCategory =
                    selectedCategory === "" ? true : gb.category === selectedCategory;

                const matchesDateFrom =
                    dateFrom === ""
                        ? true
                        : new Date(gb.start_date) >= new Date(dateFrom);

                const matchesDateTo =
                    dateTo === ""
                        ? true
                        : new Date(gb.end_date) <= new Date(dateTo);

                return (
                    matchesSchool &&
                    matchesSubject &&
                    matchesType &&
                    matchesCategory &&
                    matchesDateFrom &&
                    matchesDateTo
                );
            });

            setFilteredGradebooks(filteredData);
        };

        filterGradeBooks();
    }, [userInfo, selectedSchool, selectedSubject, selectedType, selectedCategory, dateFrom, dateTo, gradebooks]);

    useEffect(() => {
        const filterClass = () => {
            const filteredData = classes.filter(c => ((userInfo?.organization_id !== 13 && userInfo?.user_role === "Teacher") ? userInfo?.teacher_class?.some(tc => tc.class.id === c.id) : selectedSchool === "" ? true : c.classRoom.organization_id === Number(selectedSchool)) && (selectedStage === "" ? true : c.stage_id === Number(selectedStage)));
            setFilteredClasses(filteredData);
        }

        filterClass();
    }, [selectedSchool, selectedStage, userInfo, classes]);

    useEffect(() => {
        const filterTeacher = () => {
            const filteredData = teachers.filter(teacher => selectedSchool === "" ? true : teacher?.employee?.organization_id === Number(selectedSchool));
            setFilteredTeachers(filteredData);
        }

        const filterSubjects = () => {
            const filtering = subjects.filter(subject => {
                const matchesSchools =
                    selectedSchool === ""
                        ? true
                        : subject.organizations.some(
                            org => org.id === Number(selectedSchool)
                        );

                return matchesSchools;
            });
            setFilteredSubjects(filtering);
        }

        if (userInfo?.organization_id === 13) {
            filterTeacher();
            filterSubjects();
        }
    }, [selectedSchool, userInfo]);

    useEffect(() => {
        const filterStudent = () => {
            const filteredData = students.filter(student => (selectedSchool === "" ? true : student.school_id === Number(selectedSchool)) && (selectedClass === "" ? true : student.class_id === Number(selectedClass)));
            setFilteredStudents(filteredData);
        }

        filterStudent();
    }, [selectedSchool, selectedClass]);

    const loadStudentsScores = async (id) => {
        const response = await fetchWisdomGradebookScores(id);
        setStudentsScores(response)
    }

    const handleStudentScoreChange = (index, field, value) => {
        setStudentScoreRows((prev) =>
            prev.map((row, i) =>
                i === index ? { ...row, [field]: value } : row
            )
        );
    };

    const addStudentScoreRow = () => {
        setStudentScoreRows((prev) => [
            ...prev,
            {
                student_id: "",
                score: ""
            }
        ]);
    };

    const removeStudentScoreRow = (index) => {
        setStudentScoreRows((prev) =>
            prev.filter((_, i) => i !== index)
        );
    };

    const selectAllStudents = (checked) => {
        if (checked) {
            setStudentScoreRows(
                filteredStudents
                    .filter(
                        (student) =>
                            !scoredStudentIds.includes(Number(student.id))
                    )
                    .map((student) => ({
                        student_id: student.id,
                        score: ""
                    }))
            );
        } else {
            setStudentScoreRows([
                {
                    student_id: "",
                    score: ""
                }
            ]);
        }
    };

    const selectedGradebook = gradebooks.find(
        (gb) => Number(gb.id) === Number(form.template_id)
    );

    const scoredStudentIds = studentsScores.map(
        (score) => Number(score.student_id)
    );

    const handleSubmit = async (e) => {
        e.preventDefault();

        const payload = studentScoreRows.map((row) => ({
            template_id: Number(form.template_id),
            student_id: Number(row.student_id),
            teacher_id: Number(form.teacher_id),
            result: Number(row.score)
        }));

        await postInsertGradeBookScore(payload);

        navigate("/pms");
    };

    const downloadStudentsScoresExcel = () => {
        if (studentsScores.length === 0) return;

        const excelData = studentsScores.map((std, index) => ({
            "#": index + 1,
            "Student Name": `${std.student.first_name} ${std.student.middle_name} ${std.student.last_name}`,
            "Score": std.result,
        }));

        const worksheet = XLSX.utils.json_to_sheet(excelData);
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workbook, worksheet, "Students Scores");

        XLSX.writeFile(workbook, "students_scores.xlsx");
    };

    return (
        <>
            <WisdomNavbar />
            <div className="max-w-xl mx-auto px-4 py-8" dir={language ? "ltr" : "rtl"}>
                <div className="bg-white rounded-2xl shadow p-6">
                    <h1 className="text-2xl font-bold text-gray-800 mb-6">
                        {language ? "Insert Gradebook Scores" : "ادخال درجات سجل تقييم"}
                    </h1>

                    <form onSubmit={handleSubmit} className="space-y-5">
                        {/* School */}
                        {userInfo?.organization_id === 13 && <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                {language ? "School" : "مدرسة"}
                            </label>
                            <select
                                value={selectedSchool}
                                onChange={(e) => setSelectedSchool(e.target.value)}
                                className="w-full border rounded-xl px-3 py-2 bg-white focus:ring-2 focus:ring-watomsBlue"
                            >
                                <option value="" disabled>
                                    {language ? "Select school" : "اختر مدرسة"}
                                </option>
                                {schools.map((s) => (
                                    <option key={s.id} value={s.id}>
                                        {s.name}
                                    </option>
                                ))}
                            </select>
                        </div>}

                        {/* Subject */}
                        {(userInfo?.organization_id === 13 || (userInfo?.user_role === "Teacher" && userInfo?.teacher_subject?.length > 1)) && <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                {language ? "Subject" : "المادة"}
                            </label>
                            <select
                                value={selectedSubject}
                                onChange={(e) => setSelectedSubject(e.target.value)}
                                className="w-full border rounded-xl px-3 py-2 bg-white focus:ring-2 focus:ring-watomsBlue"
                            >
                                <option value="" disabled>
                                    {language ? "Select subject" : "اختر مادة"}
                                </option>
                                {filteredSubjects.map((s) => (
                                    <option key={s.id} value={s.id}>
                                        {s.name}
                                    </option>
                                ))}
                            </select>
                        </div>}

                        {/* Type */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                {language ? "Type" : "النوع"}
                            </label>
                            <select
                                value={selectedType}
                                onChange={(e) => setSelectedType(e.target.value)}
                                className="w-full border rounded-xl px-3 py-2 bg-white focus:ring-2 focus:ring-watomsBlue"
                                required
                            >
                                <option value="" disabled>
                                    {language ? "Select type" : "اختر النوع"}
                                </option>
                                <option value="اختبار تكويني">اختبار تكويني</option>
                                <option value="اختبار تجميعي">اختبار تجميعي</option>
                                <option value="مشروع تخرج">مشروع تخرج</option>
                            </select>
                        </div>

                        {/* Category */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                {language ? "Category" : "التصنيف"}
                            </label>
                            <select
                                value={selectedCategory}
                                onChange={(e) => setSelectedCategory(e.target.value)}
                                className="w-full border rounded-xl px-3 py-2 bg-white focus:ring-2 focus:ring-watomsBlue"
                            >
                                <option value="">
                                    {language ? "All categories" : "كل التصنيفات"}
                                </option>
                                <option value="theory">نظري</option>
                                <option value="practical">عملي</option>
                            </select>
                        </div>

                        {/* Date From */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                {language ? "Date From" : "التاريخ من"}
                            </label>
                            <input
                                type="date"
                                value={dateFrom}
                                onChange={(e) => setDateFrom(e.target.value)}
                                className="w-full border rounded-xl px-3 py-2 bg-white focus:ring-2 focus:ring-watomsBlue"
                            />
                        </div>

                        {/* Date To */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                {language ? "Date To" : "التاريخ الي"}
                            </label>
                            <input
                                type="date"
                                value={dateTo}
                                onChange={(e) => setDateTo(e.target.value)}
                                className="w-full border rounded-xl px-3 py-2 bg-white focus:ring-2 focus:ring-watomsBlue"
                            />
                        </div>

                        {/* Grade Book */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                {language ? "Grade Book" : "سجل التقييم"}
                            </label>
                            <select
                                value={form.template_id}
                                onChange={(e) => {
                                    setForm((p) => ({ ...p, template_id: e.target.value }));

                                    setStudentScoreRows([
                                        {
                                            student_id: "",
                                            score: ""
                                        }
                                    ]);

                                    loadStudentsScores(e.target.value);
                                }}
                                className="w-full border rounded-xl px-3 py-2 bg-white focus:ring-2 focus:ring-watomsBlue"
                                required
                            >
                                <option value="" disabled>
                                    {language ? "Select gradebook" : "اختر سجل التقييم"}
                                </option>
                                {filteredGradebooks.map((gb) => (
                                    <option key={gb.id} value={gb.id}>
                                        {gb.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Stage */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                {language ? "Stage" : "المرحلة التعليمية"}
                            </label>
                            <select
                                value={selectedStage}
                                onChange={(e) => setSelectedStage(e.target.value)}
                                className="w-full border rounded-xl px-3 py-2 bg-white focus:ring-2 focus:ring-watomsBlue"
                                required
                            >
                                <option value="" disabled>
                                    {language ? "Select stage" : "اختر مرحلة تعليمية"}
                                </option>
                                {stages.map((s) => (
                                    <option key={s.id} value={s.id}>
                                        {s.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Class */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                {language ? "Class" : "الصف"}
                            </label>
                            <select
                                value={selectedClass}
                                onChange={(e) => setSelectedClass(e.target.value)}
                                className="w-full border rounded-xl px-3 py-2 bg-white focus:ring-2 focus:ring-watomsBlue"
                                required
                            >
                                <option value="" disabled>
                                    {language ? "Select class" : "اختر فصل"}
                                </option>
                                {filteredClasses.map((c) => (
                                    <option key={c.id} value={c.id}>
                                        {c.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Teacher */}
                        {userInfo?.organization_id === 13 && <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">
                                {language ? "Teacher" : "معلم"}
                            </label>
                            <select
                                value={form.teacher_id}
                                onChange={(e) =>
                                    setForm((p) => ({ ...p, teacher_id: e.target.value }))
                                }
                                className="w-full border rounded-xl px-3 py-2 bg-white focus:ring-2 focus:ring-watomsBlue"
                                required
                            >
                                <option value="" disabled>
                                    {language ? "Select teacher" : "اختر معلم"}
                                </option>
                                {FilteredTeachers.map((teacher) => (
                                    <option key={teacher.id} value={teacher.id}>
                                        {teacher?.employee?.first_name} {teacher?.employee?.middle_name} {teacher?.employee?.last_name}
                                    </option>
                                ))}
                            </select>
                        </div>}

                        {/* Students Scores */}
                        <div>
                            <div className="flex items-center justify-between mb-2">
                                <label className="block text-sm font-medium text-gray-700">
                                    {language ? "Students Scores" : "درجات الطلاب"}
                                </label>

                                <div className="flex items-center gap-3">
                                    <label className="flex items-center gap-2 text-sm text-gray-700">
                                        <input
                                            type="checkbox"
                                            onChange={(e) => selectAllStudents(e.target.checked)}
                                            disabled={filteredStudents.length === 0}
                                        />
                                        {language ? "Select all" : "اختيار الكل"}
                                    </label>

                                    <button
                                        type="button"
                                        onClick={addStudentScoreRow}
                                        className="px-3 py-1 rounded-lg bg-watomsBlue text-white hover:opacity-90"
                                    >
                                        +
                                    </button>
                                </div>
                            </div>

                            <div className="space-y-3">
                                {studentScoreRows.map((row, index) => (
                                    <div key={index} className="flex gap-2 items-center">

                                        <select
                                            value={row.student_id}
                                            onChange={(e) =>
                                                handleStudentScoreChange(index, "student_id", e.target.value)
                                            }
                                            className="flex-1 border rounded-xl px-3 py-2 bg-white focus:ring-2 focus:ring-watomsBlue"
                                            required
                                        >
                                            <option value="" disabled>
                                                {language ? "Select student" : "اختر طالب"}
                                            </option>

                                            {filteredStudents
                                                .filter(
                                                    (s) =>
                                                        !scoredStudentIds.includes(Number(s.id)) &&
                                                        !studentScoreRows.some(
                                                            (selectedRow, selectedIndex) =>
                                                                selectedIndex !== index &&
                                                                Number(selectedRow.student_id) === Number(s.id)
                                                        )
                                                )
                                                .map((s) => (
                                                    <option key={s.id} value={s.id}>
                                                        {s.first_name} {s.middle_name} {s.last_name}
                                                    </option>
                                                ))}
                                        </select>

                                        <input
                                            type="number"
                                            value={row.score}
                                            onChange={(e) =>
                                                handleStudentScoreChange(index, "score", e.target.value)
                                            }
                                            placeholder={language ? "Score" : "الدرجة"}
                                            className="w-28 border rounded-xl px-3 py-2 focus:ring-2 focus:ring-watomsBlue"
                                            required
                                            min={0}
                                            max={selectedGradebook?.max_score}
                                        />

                                        {studentScoreRows.length > 1 && (
                                            <button
                                                type="button"
                                                onClick={() => removeStudentScoreRow(index)}
                                                className="px-3 py-2 rounded-xl bg-red-500 text-white hover:opacity-90"
                                            >
                                                -
                                            </button>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Submit */}
                        <button
                            type="submit"
                            className="w-full py-2 rounded-xl bg-watomsBlue text-white hover:opacity-90 transition"
                        >
                            {language ? "Insert Gradebook Scores" : "ادخال درجات سجل تقييم"}
                        </button>
                    </form>
                    {studentsScores.length > 0 &&
                        <div className="mt-6">
                            <div className="flex justify-between items-center mb-3">
                                <div className="text-xl font-bold">
                                    اسماء الطلاب المسجل درجاتهم:
                                </div>

                                <button
                                    type="button"
                                    onClick={downloadStudentsScoresExcel}
                                    className="px-4 py-2 rounded-xl bg-green-600 text-white hover:opacity-90"
                                >
                                    Download Excel
                                </button>
                            </div>

                            {studentsScores.map((std) => (
                                <div key={std.id} className="flex justify-between">
                                    <h1>
                                        {std.student.first_name} {std.student.middle_name} {std.student.last_name}
                                    </h1>
                                    <h1>{std.result}</h1>
                                </div>
                            ))}
                        </div>
                    }
                </div>
            </div>
        </>
    )
};

export default WisdomInsertGradeBook;